//Jquery
import "./jquery-global.js";
import $ from "jquery";

import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//Bootstrap JS
import * as bootstrap from 'bootstrap';

import AOS from 'aos';

//swiper
import Swiper from 'swiper';
import { Thumbs, Navigation, Pagination, Autoplay } from 'swiper/modules';
Swiper.use([Thumbs, Navigation, Pagination, Autoplay]);
import {initContactWizard} from "./contact-wizard";
import {setupRecaptcha} from "./recaptcha";
import { initiateCookieConsent } from "./cookie-consent";

import '@fancyapps/fancybox';

AOS.init();
var productName;

//jquery validator defaults
$.validator.setDefaults({
    errorClass: "", validClass: "", highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid").removeClass("is-valid");
        if (element.id) {
            $(element.form).find("[data-valmsg-for=" + element.id + "]").addClass("invalid-feedback");
        }
    }, unhighlight: function (element, errorClass, validClass) {
        $(element).addClass("is-valid").removeClass("is-invalid");
        if (element.id) {
            $(element.form).find("[data-valmsg-for=" + element.id + "]").removeClass("invalid-feedback");
        }
    },
});

initContactWizard();
setupRecaptcha();
initiateCookieConsent();

document.addEventListener('DOMContentLoaded', function () {

    const newSwiper = new Swiper('.homepage-swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 50000
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
    const productSwiperThumbs = new Swiper(".product-swiper-thumb", {
        spaceBetween: 20,
        slidesPerView: 2,  // Adjust this value
        centerInsufficientSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const productSwiper = new Swiper(".product-swiper", {
        modules: [Thumbs],
        spaceBetween: 10,
        autoplay: {
            delay: 5000000
        },
        thumbs: {
            swiper: productSwiperThumbs,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: updateButtonsUrl,  // called when the active slide changes
        }
    });
    const homepageSwiperSlider = new Swiper(".home-page-products-swiper", {
        spaceBetween: 20,
        slidesPerView: 4,  // Adjust this value
        centerInsufficientSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 4
            }
        }
    });
    const $pinterestButton = $('.pinterest-button');
    const $downloadButton = $('.btn-download');

    function updateButtonsUrl() {
        productName = $('[data-product-name]').attr('data-product-name');
        const currentSlide = productSwiper.slides[productSwiper.activeIndex];
        const imageUrl = $(currentSlide).find('img').attr('src');
        const encodedUrl = encodeURIComponent(imageUrl);

        $pinterestButton.attr('href', 'http://pinterest.com/pin/create/button/?url=' + encodedUrl + '&description=Description');
        $downloadButton.attr('href', '/Download/DownloadImage?imageUrl=' + encodedUrl + '&fileName=' + encodeURIComponent(productName) + '.jpeg');
    }

    // Update buttons URL at initial state
    updateButtonsUrl();

    var element = document.getElementById('customAlert');
    if (element) {
        element.style.display = 'block';
        setTimeout(() => element.style.display = 'none', 5000);
    }
    
});

var toggleElement = document.getElementById("toggle");

if (toggleElement) {
    toggleElement.addEventListener("click", function (e) {
        e.preventDefault();
        var textDiv = document.getElementById("text");
        if (textDiv && textDiv.style.maxHeight.replace("px", "") > 1.2 * 16) {
            // If block is expanded 
            textDiv.style.maxHeight = "1.2em"; // Collapse it
            this.innerHTML = "Show more +";
        } else if (textDiv) {
            textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
            this.innerHTML = "Show less";
        }
    });
}
$(document).on('click', '#finishfilter .checkbox-menu a.dropdown-item', function (event) {
    event.preventDefault();
});
$(document).on('click', '.checkbox-menu input[type="checkbox"]', function () {
    var url = new URL(window.location.href);
    if (url.searchParams.has('page')) {
        url.searchParams.delete('page');
    }
    var selectedFinishes = getSelectedFinishes();

    if (selectedFinishes.length > 0) {
        url.searchParams.set('finish', selectedFinishes.join(','));
    } else {
        url.searchParams.delete('finish');
    }

    var baseUrl = url.href.split('?')[0];
    var params = url.searchParams.toString();

    // Only add '?' and parameters if there are any parameters
    var urlStr = params ? `${baseUrl}?${params}` : baseUrl;

    window.history.pushState({}, '', urlStr);

    // Show loading spinner
    $('#product-container').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');

    var params = new URLSearchParams(window.location.search);
    params.set("categoryId", $('input[name="CategoryId"]').val());
    var searchTerm = $('input[name="searchTerm"]').val() ? $('input[name="searchTerm"]').val() : '';
    params.set("searchTerm", searchTerm);

    var getResults = $.ajax({
        url: '/ProductSearchPage/GetResultsPartial',
        type: 'GET',
        data: params.toString(),
        timeout: 50000,
    }).fail(function (jqXHR, textStatus, errorThrown) {
        console.error("/ProductSearchPage/GetResultsPartial AJAX error: " + textStatus + ' : ' + errorThrown);
    });

    var getFilters = $.ajax({
        url: '/ProductSearchPage/GetFiltersPartial',
        type: 'GET',
        data: params.toString(),
        timeout: 50000,
    }).fail(function (jqXHR, textStatus, errorThrown) {
        console.error("/ProductSearchPage/GetFiltersPartial AJAX error: " + textStatus + ' : ' + errorThrown);
    });

    $.when(getResults, getFilters).done(function (result1, result2) {
        $('#product-container').html(result1[0]);
        $('#filter-container').html(result2[0]);
    }).fail(function () {
        console.error("An AJAX error occurred");
    });

    //$.ajax({
    //    url: '/ProductSearchPage/GetResults',
    //    type: 'GET',
    //    data: params.toString(),
    //    success: function (data) {
    //        $('#product-container').html(data);
    //    },
    //    error: function (jqXHR, textStatus, errorThrown) {
    //        console.error("AJAX error: " + textStatus + ' : ' + errorThrown);
    //    },
    //    complete: function (data, textStatus) {
    //        console.log("AJAX request complete with status: " + textStatus);
    //    }
    //});

    //$.ajax({
    //    url: '/ProductSearchPage/GetFilters',
    //    type: 'GET',
    //    data: params.toString(),
    //    success: function (data) {
    //        $('#filter-container').html(data);
    //    },
    //    error: function (jqXHR, textStatus, errorThrown) {
    //        console.error("AJAX error: " + textStatus + ' : ' + errorThrown);
    //    },
    //    complete: function (data, textStatus) {
    //        console.log("AJAX request complete with status: " + textStatus);
    //    }
    //});
});

function getSelectedFinishes() {
    var selectedFinishes = [];
    $('.checkbox-menu input[type="checkbox"]:checked').each(function () {
        selectedFinishes.push($(this).val());
    });
    return selectedFinishes;
}

// product gallery
$().fancybox({
    selector: '[data-fancybox="gallery"]',
    animationEffect: false,
    buttons: [
        'close'
    ],
    touch: {
        horizontal: true,  
        momentum: true   
    },
    clickContent: false, 
    beforeShow: function (instance, slide) {
        // Remove the buttons before showing the next slide
        instance.$refs.stage.find('.lightbox-buttons').remove();

        let prevButton = $(".fancybox-button--arrow_left div");
        let nextButton = $(".fancybox-button--arrow_right div");

        if (prevButton && nextButton) {
            prevButton.html('<i class="bi bi-caret-left-fill"></i>');
            nextButton.html('<i class="bi bi-caret-right-fill"></i>');
        }
    },
    afterShow: function (instance, slide) {
        // Get the current image's URL
        var url = instance.current.src;
        // Get the title of the current image
        var description = instance.current.opts.caption;

        // Create a new Pinterest icon image element
        var $pinterestIcon = $('<img>')
            .addClass('pinterest-icon')
            .attr('src', '/Apps/ClearwaterInteriors/Content/images/icons/pinterest-icon.svg')
            .attr('alt', 'Pinterest');

        // Create a new Pinterest share button
        var $pinButton = $('<button>')
            .addClass('btn btn-outline-dark rounded-0 my-pinterest-share-button standard-button fw-600 w-100 w-md-auto')
            .text('Add to Pinterest')
            .prepend($pinterestIcon)  // Add the Pinterest icon in front of the text
            .data('url', 'http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + encodeURIComponent(description));

        // Create a new Download button
        var $downloadButton = $('<a>')
            .addClass('btn btn-outline-dark rounded-0 my-download-button standard-button fw-600 w-100 w-md-auto')
            .text('Download Image')
            .attr('href', '/Download/DownloadImage?imageUrl=' + encodeURIComponent(url) + '&fileName=' + encodeURIComponent(productName) + '.jpeg')
            .attr('download', '');

        // Add the buttons to the lightbox content area
        var $buttonsDiv = $('<div>')
            .addClass('lightbox-buttons')
            .append($downloadButton, $pinButton);
        instance.$refs.stage.append($buttonsDiv);

    },
    beforeClose: function (instance, slide) {
        // Remove the buttons when the lightbox closes
        instance.$refs.stage.find('.lightbox-buttons').remove();
    }
});

window.addEventListener('DOMContentLoaded', (event) => {
    checkWidthAndCollapse();
});

window.addEventListener('resize', (event) => {
    checkWidthAndCollapse();
});

function checkWidthAndCollapse() {
    if ($(window).width() <= 992) { 
        $('footer .collapse').removeClass('show');
    } else {
        $('footer .collapse').addClass('show');
    }
    $('#collapseFooterNewsletter').addClass('show');
    
}
$(document).on('click', '.my-pinterest-share-button', function(event) {
    event.stopPropagation();
    window.open($(this).data('url'), '_blank'); // Open the URL in a new window/tab
});

$(".pinterest-button").hover(
    function () {
        // Mouse enters
        $(this).find(".pinterest-icon").attr("src", "/Apps/ClearwaterInteriors/Content/images/icons/pinterest-icon.svg");
    }, function () {
        // Mouse leaves
        $(this).find(".pinterest-icon").attr("src", "/Apps/ClearwaterInteriors/Content/images/icons/pinterest-black-icon.svg");
    }
);

//tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));


const productVariantDropdown = document.getElementById("productVariantDropdown");

if (productVariantDropdown) {
    productVariantDropdown.addEventListener("change", function () {
        let selectedVariantId = this.value;
        window.location.href = window.location.pathname + '?variant=' + selectedVariantId;
    });
}

//set focus on search input after click on search button (mobile)
let mobileSearchCollapse = document.getElementById('search-container')
if (mobileSearchCollapse) {
    mobileSearchCollapse.addEventListener('shown.bs.offcanvas', function () {
        $(this).find('input[name="SearchTerm"]')[0].focus();
    });
}

/// scroll top always
$(document).ready(function () {
    var offcanvasNav = $('#offcanvasNav');

    offcanvasNav.on('show.bs.offcanvas', function () {
        $('.offcanvas-body').scrollTop(0);
    });
});

